var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hocCard',{attrs:{"title":_vm.$t('PW_ACTIVATION_TITLE'),"subtitle":_vm.$t('PAGE_SUBTITLE'),"variant":"primary"},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('areaPasswordForgottenActivation')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }